import React from 'react';

const GeneralInformation = () => {
  return (
    <div>
      <h1> מערכת טלפונית לבינה מלאכותית</h1>
      <h2> chat gpt טלפוני</h2>
      <h2> מספרי טלפון (רשימה חלקית)</h2>
      

      
      <ul>
        <li><strong>⭐ 033765432  </strong></li>
        <li><strong>⭐ 023765432  </strong> קו יעודי לקומה הכשרה , לא כולל ניהול שיחה ולא כולל חדשות , וחלק מישומי הזירה החופשית ועוד</li>
        <li><strong>⭐ 023765433  </strong>קו יעודי לרישום עסקים לזירת הניציגים</li>
        <li><strong>⭐ 15676543203  </strong> קו יעודי לתושבי חו"ל</li>
        <li><strong>⭐ 15676543201  </strong> קו יעודי לתושבי חו"ל</li>
        </ul>
        <br />
      <h3>דרכי יצירת קשר</h3>
      <ul>
      <li><strong>⭐השארת הודעה במספרי הטלפונים הנ"ל דרך התפריט</strong> 033765432 ועוד</li>
      </ul>
      <h3>דרכי יצירת קשר עם  מוטו פיתוח אפליקציות ואתרים</h3>
      <ul>
       <li><a href="https://motto.co.il" target="blank" style={{ all: "revert" }}><strong>⭐מוטו, פיתוח אפליקציות ואתרים - דרך האתר</strong> https://motto.co.il</a></li>
      <li><strong>⭐מוטו, פיתוח אפליקציות ואתרים - קשר טלפוני</strong> 0512635325</li>
      <li><a href="mailto:omer@motto.co.il" target="blank" style={{ all: "revert" }}><strong>⭐מוטו, פיתוח אפליקציות ואתרים - אימייל</strong> omer@motto.co.il</a></li>
      </ul>
        
    </div>
  );
};

export default GeneralInformation;
